// @flow
import React from "react";

import SectionHeader from "./commons/SectionHeader";
import Section from "./commons/Section";
import CoverPic from "./commons/CoverPic";

const STYLE_LI = {
  margin: "10px 0",
};

const Histoire = () => {
  return (
    <div style={{}}>
      <SectionHeader>Le champagne de Villepin</SectionHeader>
      {/* <CoverPic src="vignes_automne.jpg" /> */}
      <Section>
        <p style={{ textAlign: "justify", margin: 20 }}>
          <h4 style={{ color: "#c1152e", textTransform: "capitalize" }}>
            La maison de Villepin : un terroir comme autrefois
          </h4>
          Venez découvrir une maison de champagne qui respecte le terroir.
          <br />
          Près de Reims, notre maison cultive ses vignes à Boursault sur les
          coteaux de la Marne, à côté d’Epernay.
          <br />
          Depuis de nombreuses années, nous nous sommes engagé pour une
          viticulture durable en enherbant complètement nos premières vignes.
          <br />
          Différentes plantes sont apparues sur nos coteaux et nous avons choisi
          de laisser la nature prendre place afin de simplement respecter nos
          vignes au maximum. Grâce à cette méthode traditionnelle, nous trouvons
          de nombreuses plantes variées au sein de nos vignes : ortie, chardon,
          menthe, fraises des bois…
          <br />
          <br />
          <p>
            <a
              href="https://agriculture.gouv.fr/la-certification-en-agriculture-biologique"
              target="_blank"
            >
              <img
                src="AB.png"
                alt="Label AB"
                style={{ width: 100, height: 139, padding: 10, float: "right" }}
              />
            </a>
            Pourquoi élever nos vignes ainsi ?
            <br />
            Chaque plante est un apport pour notre{" "}
            <a href="https://boutique.champagnedevillepin.fr/">champagne</a>:
            certaines attirent des insectes pollinisateurs, d’autres régulent
            des populations à risque pour nos vignes, quelques-unes vont
            favoriser l’infiltration des pluies pour le raisin.
            <br />
            Nous savons qu'une viticulture durable en champagne est le meilleur
            des engagements.
            <br />
            Convaincus comme les grandes maisons de champagne de l’importance
            des enjeux environnementaux, notre maison a démarré sa conversion
            biologique en 2021 et obtenu sa certification en agriculture
            biologique en 2024. Notre sol bénéficie particulièrement d’une vie
            complète et exceptionnelle grâce à sa biodiversité.
            <br />
            Pour cette raison,{" "}
            <a href="https://boutique.champagnedevillepin.fr/">
              notre champagne
            </a>{" "}
            reflètent le meilleur de nos terroirs. Ainsi, nos bouteilles vous
            feront-elles vivre une expérience unique, idéale pour votre mariage
            ou toute autre réjouissance.
          </p>
        </p>
        <div style={{ flex: 1, margin: 20, minWidth: 300 }}>
          <a href="portrait.jpg" target="_blank">
            <img
              src="portrait.jpg"
              alt="Portrait dans les vignes"
              width="100%"
            />
          </a>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
          }}
        >
          <div style={{ flex: 1, margin: 20, minWidth: 300 }}>
            <h4 style={{ color: "#c1152e", textTransform: "capitalize" }}>
              Champagne de Villepin : Notre méthode
            </h4>
            <p style={{ textAlign: "justify" }}>
              Un objectif, mettre en valeur ce que nos vignes nous offrent
              chaque année, du Chardonnay et du Meunier principalement.
              <br />
              <a href="https://boutique.champagnedevillepin.fr/">
                Nos champagnes
              </a>{" "}
              sont élevés sur lies, puis sur lies fines. Cette fermentation
              avant mise en bouteille les rend pétillants, délicats et subtils.
              <br />
              Notre champagne n’est pas filtré. Il garde ainsi toute sa matière
              et développe un potentiel de garde bien supérieur. Ainsi
              bénéficie-t-il d’un élevage en bouteille minimal de 2 à 3 ans et
              d’un an de repos après dégorgement dans nos caves.
              <br />
              Maintenant depuis quelques années, une partie de nos vins est
              vinifiée en fûts ou sans fermentation malo-lactique pour de
              nouvelles cuvées futures !
              <br />
              <span style={{ fontWeight: "bold" }}>
                Notre nouveauté ?{" "}
                <a href="https://boutique.champagnedevillepin.fr/">
                  Le Coteau Champenois
                </a>{" "}
                dit « le Clos des potiers ».
              </span>
            </p>
          </div>
          <div style={{ flex: 1, margin: 20, minWidth: 300 }}>
            <a href="20191011_160719.jpg" target="_blank">
              <img
                src="20191011_160719.jpg"
                alt="Bruno verre à la main"
                width="100%"
              />
            </a>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
          }}
        >
          <div style={{ flex: 1, margin: 20, minWidth: 300 }}>
            <a href="20191011_160615.jpg" target="_blank">
              <img
                src="20191011_160615.jpg"
                alt="Bruno avec ses cuves"
                width="100%"
              />
            </a>
          </div>
          <div style={{ flex: 1, margin: 20, minWidth: 300 }}>
            <h4 style={{ color: "#c1152e", textTransform: "capitalize" }}>
              Dans nos bouteilles
            </h4>
            <p style={{ textAlign: "justify" }}>
              <ul>
                <li style={STYLE_LI}>
                  Brut Vignoble : la structure du Chardonnay, la finesse et le
                  fruit du Meunier
                </li>
                <li>Blanc de Noirs : la Gourmandise, la rondeur du Meunier</li>
                <li style={STYLE_LI}>
                  Brut Vignoble rosé : les Fruits rouges et la structure du
                  Meunier
                </li>
                <li style={STYLE_LI}>Millésime 2018 : une grande année</li>
                <li style={STYLE_LI}>
                  La Folle Pensée : une bouteille ficelée à l'ancienne pour un
                  champagne d'exception 100% Meunier
                </li>
                <li style={STYLE_LI}>
                  La Chalterie : un champagne blanc de blanc vignifié et élevé
                  en fût pendant 12 mois, une dégustation incontournable pour
                  les connaisseurs
                </li>
                <li style={STYLE_LI}>
                  Le Coteau Champenois « Le clos des potiers » : une autre
                  expression de notre terroir !
                </li>
              </ul>
            </p>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Histoire;



// WEBPACK FOOTER //
// ./src/Histoire.js